import { makeStyles } from "@material-ui/core";
import { colors } from "../../../../../shared/utils";

const useStyles = makeStyles(() => ({
  formContainer: {
    display: "flex",
    flexDirection: "column",
    rowGap: "16px",
    padding: "0px",
    position: "relative",
  },
  label: {
    marginLeft: "16px",
    marginBottom: "8px",
    color: colors.blueDarken,
  },
  submitBottom: {
    color: colors.blueDarken,
    background: colors.yellow,
    borderRadius: "19px",
    "&:hover": {
      background: colors.yellow,
    },
  },
  searchIcon: {
    padding: 8,
    "&:hover": { background: "none" },
  },
}));

export default useStyles;
